<template>
  <div>
    <van-nav-bar :title="title" style="position:fixed;width: 100%;"  >
    </van-nav-bar>

    <div  style="padding-top: 45px">
       </div>

         <van-row style="margin-top50px;background-color: white;">

             <van-search
               v-model="value"
               show-action
               placeholder="请输入合同关键词或者编号"
               @search="onSearch"
             >
              <template #action>
              <div @click="onSearch">搜索</div>
            </template>
  </van-search>

         </van-row>

    <van-cell-group>
        <van-field
        v-model="form.htbh"
        label="合同编号"
        placeholder="请在上方搜索栏内搜索合同"
         :label-width="100"

        ></van-field>
        <van-field
        v-model="form.fpmc"
        label="发票抬头"
        placeholder="请输入发票抬头"
          clearable
         :label-width="100"
        ></van-field>
        <van-field
        v-model="form.fpsh"
        label="税号"
        placeholder="请输入税号"
          clearable
         :label-width="100"
        ></van-field>
        <van-field
        v-model="fpxx.dizhi"
        label="公司地址"
        placeholder="请输入公司地址"
          clearable
         :label-width="100"
        ></van-field>
        <van-field
        v-model="form.lxrdh"
        label="公司电话"
        placeholder="请输入公司电话"
          clearable
         :label-width="100"
        ></van-field>
        <van-field
        v-model="form.fpkhyh"
        label="开户行"
        placeholder="请输入开户行"
          clearable
         :label-width="100"
        ></van-field>
        <van-field
        v-model="form.fpyhzh"
        label="开户行账号"
        placeholder="请输入开户行账号"
          clearable
         :label-width="100"
        ></van-field>
        <van-field
          v-model="form.kpsy"
          label="开票事由"
          placeholder="请输入开票事由"

          clearable
          :label-width="100"
        >
        </van-field>
       <choice
        type="xm_htkplx"
        label="开票类型"
        v-model = "form.kplx"
         :labelWidth="100"
       ></choice>
       <choice
        type="xm_wtdw"
        label="委托单位"
        v-model = "form.wtdw"
         :labelWidth="100"
       ></choice>

        <van-field
            v-model="form.kpje"
            label="开票金额"
            placeholder="输入开票金额"
            type="number"
            required
            clearable
            :label-width="100"
          />

            <choice
            type="xm_cysl"
            label="税率"
            v-model = "form.tax"
             :labelWidth="100"

            ></choice>

          <van-field name="uploader" label="上传附件" >
            <template #input>
              <FileUpload v-model="form.fjwj"></FileUpload>
               </template>
              </van-field>
                <van-field
                      v-model="form.bz"
                      label="备注"
                      placeholder="输入备注"
                         rows="2"
                      autosize
                      clearable
                      :label-width="100"
                    />

    </van-cell-group>

    <div style="background-color: white;height: 800px;"></div>
    <van-tabbar  active-color="#ff0000" style="color: bisque;">
      <van-tabbar-item icon="share"  @click="tijiao">提交</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import choice from '../../components/Dict/choice.vue'
import FileUpload from '../../components/uploadFile/index.vue'
import {getXsht} from '@/api/xm/xsht'
import {addHtkp} from '@/api/xm/htkp'
import {updateInfo} from '@/api/xm/info'
export default {
  name: 'kpsq',
  components: {
    choice: choice,
    FileUpload: FileUpload
  },
  data () {
    return {

      id: 0,
      value: null,
      title: '开票申请',
      titlelist: [],
      loading: false,
      form: {},
      fpxx: {}
    }
  },
  created () {
    // const id  = this.$route.params && this.$route.params.bzId;

  },
  mounted () {
    this.getKpht()
  },
  activated () {

  },
  methods: {
    getKpht () {
      const kpht = this.$store.state.kpht
      if (kpht.id) {
        getXsht(kpht.id).then(res => {
          console.log(res)
          const data = res.data
          let fpxx = {}
          let form = {}
          form.htbh = kpht.htbh
          form.lskpje = kpht.kpje
          form.htid = data.id
          form.htbh = data.htbh
          form.xmid = data.xmid
          form.htje = data.htje
          form.jsje = data.yjsje
          form.wtdw = data.wtdw
          const kuInfo = data.kuInfo
          fpxx.mc = kuInfo.mc
          fpxx.sh = kuInfo.sh
          fpxx.dizhi = kuInfo.dizhi
          fpxx.lxrdh = kuInfo.lxrdh
          fpxx.khyh = kuInfo.khyh
          fpxx.yhzh = kuInfo.yhzh
          fpxx.id = kuInfo.id
          form.fpmc = kuInfo.mc
          form.fpsh = kuInfo.sh
          form.lxrdh = kuInfo.lxrdh
          form.fpkhyh = kuInfo.khyh
          form.fpyhzh = kuInfo.yhzh
          this.form = form
          this.fpxx = fpxx
        })
      }
    },
    onDateConfirm () {},
    onSearch () {
      this.$router.push({ path: '/xzhtlist', query: { keywords: this.value } })
    },
    jssf () {
      console.log('jssf:', this.form.tax)
      const sfje = (this.form.kpje * this.form.tax / (1 + this.form.tax)).toFixed(2)

      this.$set(this.form, 'sfje', sfje)
    },
    onCancel () {
      this.value = null
    },
    xzsl (value) {

    },
    keepsame () {
      this.fpxx.mc = this.form.fpmc

      this.fpxx.sh = this.form.fpsh

      this.fpxx.lxrdh = this.form.lxrdh
      this.fpxx.khyh = this.form.fpkhyh
      this.fpxx.yhzh = this.form.fpyhzh
    },

    tijiao () {
      if (!this.form.kpje) {
        this.$toast.fail('金额不能为空')
        return
      }
      this.$dialog.confirm({
        message: '确认开票申请吗？',
        beforeClose: (action, done) => {
          if (action === 'confirm') {
            this.keepsame()
            updateInfo(this.fpxx)
            addHtkp(this.form).then(res => {
              this.$toast.success('开票申请完成')
              done()
              this.$router.push({path: '/work'})
            })
          } else {
            done()
          }
        }
      })
    }

  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/KaiPiao/index.vue